// extracted by mini-css-extract-plugin
export default {"Product-info-header--wrapper":"ProductInfoHeader_Product-info-header--wrapper__HnjST","Product_price_container":"ProductInfoHeader_Product_price_container__G9suI"};